import BankAccountTypeSelect from './BankAccountTypeSelect';

export default BankAccountTypeSelect;
